import React from 'react';

interface OwnProps {
    value?: string;
    disabled?: boolean;
}

type Props = OwnProps;

export class FormOption extends React.Component<Props, {}> {
    public render() {
        return (
            <option value={this.props.value} disabled={this.props.disabled}>{this.props.children}</option>
        )
    }
}

export default FormOption;